<div class="index-shell">
    <app-header [breadcrumbs]="['Reports']" mainHeading="Reports" [links]="['/reports']">
        <div headingButton>
            <button class="add-button" cll-button colour="variant" (click)="runReport()">
                <cll-icon>add</cll-icon>
                Run report
            </button>
        </div>
    </app-header>

    <div class="reports-shell">
        <div>
            <div class="tabs-container">
                <cll-horizontal-tabs [appearance]="tabAppearance" [tabItems]="tabItems" [currentTabId]="currentTabId"
                                     (currentTabIdChange)="currentTabIdChange($event)" />

                @if (this.isActiveReportsTabOpen) {
                    <app-reports-active-reports-tab />
                }

                @if (this.isHistoryTabOpen) {
                    <app-reports-history-tab />
                }

            </div>
        </div>
    </div>
</div>
